import API from "../../services/api";
import { idempotencyHeaders } from "../../utils/idempotency";

export function previewResponse(batchId, { bankCode, file }) {
  const form = new FormData();
  form.append("bank_code", bankCode);
  form.append("file", file);
  return API.post(`/disbursement/salary-batches/${batchId}/response/preview`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
}

export function applyResponse(batchId, { bankCode, file, idempotencyKey } = {}) {
  const form = new FormData();
  form.append("bank_code", bankCode);
  form.append("file", file);
  return API.post(`/disbursement/salary-batches/${batchId}/response/apply`, form, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...idempotencyHeaders("bank-response-apply", idempotencyKey),
    },
  }).then((r) => r.data);
}
